module.exports = __webpack_public_path__ + "img/icon_distanceday_download_code.24e0390f.png";